import React, { useState, useEffect } from 'react';
import { Award } from 'lucide-react';
import { callsAPI } from '../services/api';

const CallToppers = () => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await callsAPI.getAll();
      const calls = response.data || [];
      
      // Calculate agent stats
      const agentStats = {};
      calls.forEach(call => {
        const agent = call.agent_name || 'Unknown';
        if (!agentStats[agent]) {
          agentStats[agent] = { calls: 0, connected: 0 };
        }
        agentStats[agent].calls++;
        if (call.status === 'Connected' || call.status === 'Answered') {
          agentStats[agent].connected++;
        }
      });

      const agentList = Object.entries(agentStats)
        .map(([name, stats]) => ({
          name,
          calls: stats.calls,
          conversion: stats.calls > 0 ? Math.round((stats.connected / stats.calls) * 100) + '%' : '0%'
        }))
        .sort((a, b) => b.calls - a.calls);

      setAgents(agentList);
    } catch (error) {
      console.error('Error loading call toppers:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="call-toppers-page">
      <h2 className="text-xl font-bold text-gray-800">Top Performing Agents</h2>
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <table className="w-full text-left">
            <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                    <th className="px-6 py-4 text-xs font-semibold text-gray-500 uppercase">Rank</th>
                    <th className="px-6 py-4 text-xs font-semibold text-gray-500 uppercase">Agent Name</th>
                    <th className="px-6 py-4 text-xs font-semibold text-gray-500 uppercase">Total Calls</th>
                    <th className="px-6 py-4 text-xs font-semibold text-gray-500 uppercase">Connection Rate</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
                {agents.map((agent, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                        <td className="px-6 py-4">
                            {index === 0 ? <Award className="text-yellow-500" size={24} /> : 
                             index === 1 ? <Award className="text-gray-400" size={24} /> :
                             index === 2 ? <Award className="text-amber-600" size={24} /> :
                             <span className="text-gray-500 font-medium">{index + 1}</span>}
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-900">{agent.name}</td>
                        <td className="px-6 py-4">{agent.calls}</td>
                        <td className="px-6 py-4 text-green-600 font-bold">{agent.conversion}</td>
                    </tr>
                ))}
                {agents.length === 0 && (
                  <tr>
                    <td colSpan={4} className="px-6 py-8 text-center text-gray-500">
                      No call data available
                    </td>
                  </tr>
                )}
            </tbody>
        </table>
      </div>
    </div>
  );
};

export default CallToppers;
